import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// Import global CSS files
import '../public/assets/css/bootstrap.min.css';
import '../public/assets/css/fontawesome.min.css';
import '../public/assets/css/magnific-popup.min.css';
import '../public/assets/css/swiper-bundle.min.css';
import '../public/assets/css/style.css';

// Or import from public folder
// import '/assets/css/bootstrap.min.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);